export const stripProtocolInUrl = (url = '') => {
  return url.replace(/^https?:\/\/(www\.)?/, '');
};

/**
 * "John Smith" -> "JS". Falls back to a single letter for mononyms, and
 * ignores middle names so "Mary Jane Watson" is "MW", not "MJ".
 *
 * Non-letter tokens are dropped so test/staging names like
 * "Sergio (Staging OA) 1" don't yield a digit or a bracket as an initial.
 */
export const getInitials = (fullName = '') => {
  const parts = fullName
    .trim()
    .split(/\s+/)
    .map((part) => part.replace(/[^\p{L}]/gu, ''))
    .filter(Boolean);

  if (!parts.length) return '';

  const first = parts[0];
  const last = parts.length > 1 ? parts[parts.length - 1] : '';

  return `${first.charAt(0)}${last.charAt(0)}`.toUpperCase();
};
